<template>
  <div>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12 mg-top-1">
          <b-button variant="primary" @click="toCreate()" v-if="power['添加']">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.name"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <b-button class="btn-sm" variant="primary" @click="toCreate()" v-if="power['添加']">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <!-- <th scope="col" style="width: 70px;">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th> -->
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">名称</th>
                  <th scope="col">更新日期</th>
                  <th scope="col">创建时间</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <!-- <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td> -->
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.name }}</td>
                  <td>{{ item.updatedAt || "--" }}</td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>
                    <span v-if="item.id != 1">
                      <button
                        v-if="power['移除']"
                        type="button"
                        class="btn-sm btn btn-danger"
                        @click="remove(item)"
                      >
                        移除
                      </button>
                    </span>

                    <!-- <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item px-2" @click="toDetail(item)">
                        <a v-b-tooltip.hover title="编辑">
                          <i class="bx bxs-edit"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="remove(item)">
                        <a v-b-tooltip.hover title="移除">
                          <i class="bx bx-trash"></i>
                        </a>
                      </li>
                    </ul> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-list-loading ref="loading"></app-list-loading>
          <pagination ref="page" @pageCallback="pageCallback"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import roles from "@/server/api/roles";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        name: "",
        type: 2,
        mediaId: JSON.parse(localStorage.chosedMedia).id,
      },
      items: [],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.getList();
    this.power = this.utils.currentPower("创作平台-角色管理");
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      console.log("搜索参数", params);
      this.$refs.loading.show();
      this.items = [];
      roles.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data.items) {
            if (this.$refs.loading) {
  this.$refs.loading.hide(resp.data.items);
}
            let ids = [];
            resp.data.items.map((item) => {
              if (item.id != 1) {
                ids.push(item.id);
              }
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            // this.items.forEach((v, i) => {
            //   if (v.id == 1) {
            //     console.log(v);
            //     this.items.splice(i, 1);
            //   }
            // });
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
  if (this.$refs.page) {
    this.$refs.page.setPages(pages);
  }
});
          }
        } else {
          if (this.$refs.loading) {
  this.$refs.loading.hide();
}
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "mediaRoleDetail",
        query: { mediaId: this.pageParams.mediaId },
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "mediaRoleDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "mediaRoleDetail",
          query: { id: item.id },
        });
      }
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.name = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    remove(item) {
      Swal.fire({
        title: "确定移除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "移除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.id = item.id;
          roles.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal({
                icon: "error",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
  },
};
</script>
